export const getHeaderToken = (token) => {
    return {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
    };
};
